var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00035 0.0908203C4.65325 0.0908203 1.79482 2.12646 0.636719 4.99991C1.79482 7.87337 4.65325 9.909 8.00035 9.909C11.3475 9.909 14.2059 7.87337 15.364 4.99991C14.2059 2.12646 11.3475 0.0908203 8.00035 0.0908203ZM8.00035 8.27264C6.15275 8.27264 4.65325 6.80646 4.65325 4.99991C4.65325 3.19337 6.15275 1.72718 8.00035 1.72718C9.84796 1.72718 11.3475 3.19337 11.3475 4.99991C11.3475 6.80646 9.84796 8.27264 8.00035 8.27264ZM8.00035 3.03628C6.88912 3.03628 5.99209 3.91337 5.99209 4.99991C5.99209 6.08646 6.88912 6.96355 8.00035 6.96355C9.11159 6.96355 10.0086 6.08646 10.0086 4.99991C10.0086 3.91337 9.11159 3.03628 8.00035 3.03628Z",
    fill: "#00A1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f7a5034a05a583f171bc8c6904021c49.svg";
export { ForwardRef as ReactComponent };